<template>
    <div class="wrap" id="cwrap">
        <Bgcanvas></Bgcanvas>
        <acHead></acHead>
        <div class="content  el-col el-col-24">
            <div class="con-wrap el-col">
                <!--<acSide></acSide>-->
                <div class="content-box" v-if="isRouterAlive">
                    <acContent></acContent>
                    <acFoot></acFoot>
                </div>
            </div>
        </div>
        <el-dialog
                title="请扫描关注公众号"
                :visible.sync="showQrCode"
                size="tiny">
                            <span>绑定微信后，可实时收到备案事项提醒消息，以及系统更新公告等内容推送。
                    请尽快用微信扫码绑定您的账号。</span>
            <img class="qr-img" :src="qrCodeUrl"/>
            <!--<span slot="footer" class="dialog-footer">-->
            <!--<el-button @click="dialogVisible = false">取 消</el-button>-->
            <!--<el-button type="primary" @click="dialogVisible = false">确 定</el-button>-->
        </el-dialog>
    </div>
</template>
<script>
    import acHead from './Header.vue'
    // import acSide from './SidebarItem.vue'
    import acContent from './Content.vue'
    import acFoot from './Footer'
    import Bgcanvas from './Bgcanvas'
    import account from '../../data/ucenter/account.js'
    import Wechat from '../../data/ucenter/wechat'

    export default {
        provide() { // 注册一个方法
            return {
                reload: this.reload
            }
        },
        data() {
            return {
                info: {},
                isRouterAlive: true,
                showQrCode: false,
                qrCodeUrl: ''
            }
        },
        mounted() {
            (async () => {
                let user = await account.get_profile();
                this.get_wechat_account(user);
                // let user = JSON.parse(sessionStorage.allUser);
                // console.log(user, 'user');
                // (async() => {
                //     try {
                //         let param = {};
                //         param.uid = this.statelist.uid;
                //         let wechatState = await account.get_wechat_profile(param)
                //         console.log(wechatState,'wcstate')
                //         if(wechatState) {
                //             this.statelist.openId = wechatState.openId;
                //             this.statelist.wechatNickName = wechatState.nickName;
                //             console.log(this.statelist.openId,'this.statelist.openId')
                //             // sessionStorage.allUser = JSON.stringify(user)
                //             this.hasWechat = true;
                //         }
                //     } catch (error) {
                //         console.log(error,"error")
                //         this.$message.error('网络错误,请稍后重试')
                //     }
                // })()
            })()
        },
        methods: {
            //获取用户微信信息
            get_wechat_account(user) {
                let param = {};
                param.uid = user.uid;
                (async () => {
                    try {
                        let wechatState = await account.get_wechat_profile(param)
                        if (wechatState) {
                            // user.openId = wechatState.openId;
                            // user.wechatNickName = wechatState.nickName;
                            // // console.log(state,'wechat_state')
                            // sessionStorage.allUser = JSON.stringify(user)

                            // console.log('已经绑定微信')
                        } else {
                            (async () => {
                                try {
                                    let param = {};
                                    param.uid = user.uid;
                                    // console.log(param, 'param');
                                    let url = await Wechat.qrCodeUrl(param);
                                    this.qrCodeUrl = url;
                                    this.showQrCode = true;
                                } catch (error) {
                                    console.log(error, "error")
                                    this.$message.error('网络错误,请稍后重试')
                                }
                            })()
                        }
                    } catch (error) {
                        console.log(error, "error")
                        this.$message.error('网络错误,请稍后重试')
                    }
                })()
            },
            reload() {
                this.isRouterAlive = false
                this.$nextTick(function () {
                    this.isRouterAlive = true
                    // console.log('reload')
                })
            }
        },
        components: {
            acHead,
            acContent,
            acFoot,
            // acSide,
            Bgcanvas
        }
    }

</script>
<style lang="stylus" scoped>
    .wrap {
        min-width: 1200px;
        min-height: 100%;
        background: #f8f8fa;
        position: relative;
        overflow: hidden;

        &:after {
            content: '';
            display: block;
            clear: both;
            visibility: hidden;
            line-height: 0;
            height: 0;
            font-size: 0;
        }
    }

    .content {
        display: flex;
        min-height: calc(100% - 90px);
        overflow: hidden;
        width: 100%;
        z-index: 1;
        background: #f8f8fa;
        box-sizing: border-box;
    }

    .con-wrap {
        display: flex;
        bottom: 0px;
        overflow: hidden;
        width: 100%;
        padding: 0 30px;
        margin: 0 auto;
        position: relative;

        .content-box {
            flex: 1;
            position: relative;
            overflow-x: hidden;
        }
    }

    .qr-img {
        width: 80%;
        height: 80%;
        margin-left: 10%;
    }
</style>



// WEBPACK FOOTER //
// Wrap.vue?766e081c